import { render, staticRenderFns } from "./TableHeaderEditor.vue?vue&type=template&id=5e7c922d&scoped=true"
import script from "./TableHeaderEditor.vue?vue&type=script&lang=js"
export * from "./TableHeaderEditor.vue?vue&type=script&lang=js"
import style0 from "./TableHeaderEditor.vue?vue&type=style&index=0&id=5e7c922d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7c922d",
  null
  
)

export default component.exports